import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SidebarService } from './core/services/sidebar.service';
import { HeaderService } from './core/services/header.service';
import { InactivityService } from './core/services/inactivity.service';
import { AuthService } from './core/services/auth.service';

const PUBLIC_ROUTES = ['/login', '/onboard'];

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class AppComponent implements OnInit {
  title = 'HRMS';
  expanded: boolean = true;
  sidebarVisible: boolean = !PUBLIC_ROUTES.some(r => window.location.pathname.includes(r) || window.location.hash.includes(r));

  constructor(
    private sidebarService: SidebarService,
    private headerService: HeaderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private inactivity: InactivityService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.split('?')[0];
        const isPublic = PUBLIC_ROUTES.some(r => url === r || url.startsWith(r + '/') || url.startsWith(r + '?'));
        this.sidebarVisible = !isPublic;
        this.cdr.markForCheck();
        if (isPublic) {
          this.inactivity.stop();
        } else if (this.authService.getToken()) {
          this.inactivity.start();
        }
      }
    });

    const initUrl = window.location.hash.replace('#', '') || window.location.pathname;
    const initPublic = PUBLIC_ROUTES.some(r => initUrl === r || initUrl.startsWith(r));
    if (!initPublic && this.authService.getToken()) {
      this.inactivity.start();
    }

    this.sidebarService.subscribeToHide((data: boolean) => {
      this.sidebarVisible = data;
      this.cdr.markForCheck();
    });
    this.headerService.subscribe((title: string) => {
      this.title = title;
      this.cdr.markForCheck();
    });
    this.sidebarService.subscribeToEvent((data: boolean) => {
      this.expanded = data;
      this.cdr.markForCheck();
    });
  }
}
